export default {
	title: 'Partes interessadas',
	context_best: 'Favorável',
	context_worse: 'Hostil',
	zones: {
		positive: 'Favorável',
		positive_line2: 'Zona',
		neutral: 'Neutro',
		negative: 'Hostil',
		negative_line2: 'Zona',
		point_of_view_line1: 'Ponto',
		point_of_view_line2: 'de',
		point_of_view_line3: 'vista'
	},
	alignment: {
		title_1: 'Partes interessadas',
		title_2: 'alinhamento'
	},
	tabs: {
		general: {
			title: 'Geral'
		},
		links: {
			title: 'Vínculos'
		},
		comments: {
			title: 'Histórico'
		},
		filters: {
			title: 'Filtros de vista'
		},
		export: {
			title: 'Exportar',
			image: 'Exportar radar como imagem'
		},
		risks: {
			title: 'Riscos'
		},
		bot: {
			title: 'IA'
		},
		tags: {
			title: 'Etiquetas',
			assigned: 'Etiquetas atribuídas',
			unassigned: 'Etiquetas não atribuídas'
		},
		disabled: {
			title: 'Desativados'
		}
	},
	summary: {
		key_drivers: 'Fatores-chave',
		scenario_score: 'Pontuação do cenário',
		max_value: 'máx. {{value}}',
		legend: {
			current: 'Atual',
			scenario: 'Cenário'
		}
	},
	all_tags: 'Filtro de etiquetas',
	links: 'Mostrar todos os vínculos',
	no_tag: 'Sem etiqueta',

	all_icons: 'Filtro de ícones',
	no_icon: 'Sem ícone',

	all_stakes: 'Filtro de interesses',
	all_constraints: 'Filtro de indicadores',
	all_risks: 'Filtro de riscos',
	all_opportunities: 'Filtro de aberturas',
	onboarding: {
		title: 'Revisão das partes interessadas',
		description:
			'Os atores que pesam sobre o seu tema estão posicionados no radar conforme a sua influência e postura. Verifique o alinhamento e ajuste se a sua leitura for diferente.'
	}
};
